import { parseAsBoolean, parseAsString, useQueryStates } from '@/libs/nuqs'

const useWorkflowListParams = () => {
	const [params, setParams] = useQueryStates({
		q: parseAsString,
		sortBy: parseAsString,
		sortDir: parseAsString,
		createWorkflow: parseAsBoolean,
	})

	return { ...params, setParams }
}

export { useWorkflowListParams }
